import React, {useEffect, useRef} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import useQueryTraderMapProjects from '../../hooks/api/tradermap_project/useQueryTraderMapProjects'
import Text from '../../components/text/Text'
import WizImage from '../../components/image/WizImage'
import {useTime} from '../../utils/time'
import useQueryTraderMapCampaign from '../../hooks/api/tradermap_campaign/useQueryTraderMapCampaign'
import WizButton from '../../components/button/WizButton'
import useQueryTraderMapProjectDetail from '../../hooks/api/tradermap_project/useQueryTraderMapProjectDetail copy'
import UnderLineInput from '../../components/input/UnderLineInput'
import WizSelectButton from '../../components/button/WizSelectButton'
import {postUploadImage} from '../../apis/image/postUploadImage'
import {createTraderMap} from '../../apis/tradermap_project/create'
import {editTraderMap} from '../../apis/tradermap_project/edit'
import WizSpinner from '../../components/spinner/WizSpinner'
import img_placeholder from '../../assets/images/placeholder.png'

interface IProps {
    className?: string
}

export function TraderMap({className}: IProps) {
    const [active, setActive] = React.useState<'default' | 'create' | 'detail'>('default')
    const {data, refetch} = useQueryTraderMapProjects()
    const [id, setId] = React.useState<string>('')
    const {data: detailData, refetch: detailRefetch, isLoading: isDetailLoading} = useQueryTraderMapProjectDetail(id)

    const {localTimeString} = useTime()

    const [body, setBody] = React.useState({
        symbol: '',
        symbol_image: '',
        status: 'active',
        priority: undefined,
    })

    const selectList = [
        {id: 'active', value: 'Active'},
        {id: 'inactive', value: 'InActive'},
    ]

    const symbolImageRef = useRef<any>()

    const onChangeThumbnail = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            setBody(prev => ({...prev, symbol_image: result?.image_url}))
        }
    }

    useEffect(() => {
        if (detailData) {
            setBody({
                symbol: detailData?.symbol,
                symbol_image: detailData?.symbol_image,
                status: detailData?.status,
                priority: detailData?.priority,
            })
        }
    }, [detailData])

    // drag and drop items priority
    const [items, setItems] = React.useState(data || [])
    const [draggedItem, setDraggedItem] = React.useState(null)

    return (
        <PageLayout title={'Trader Map Project'}>
            <div>
                <WizButton
                    text={'New Trader Map Project'}
                    type="primary"
                    onClick={() => {
                        setBody({
                            symbol: '',
                            symbol_image: '',
                            status: 'active',
                            priority: data?.sort((a, b) => b.priority - a.priority)?.at(0)?.priority + 1,
                        })
                        setActive('create')
                        setId('')
                    }}
                />
            </div>
            <div className="grid grid-cols-[360px_1px_1fr] gap-x-[40px] mt-[30px] w-full justify-center">
                <article className=" max-h-[610px] overflow-auto pr-[5px]">
                    {data
                        ?.sort((a, b) => b.priority - a.priority)
                        ?.map(project => (
                            <div
                                key={project?.id}
                                onClick={() => {
                                    setActive('detail')
                                    setId(project?.id)
                                }}
                                className="mb-4 p-4 border border-line02 bg-white hover:border-primary cursor-pointer rounded-[5px] grid grid-cols-[40px_1fr_80px_60px] items-center gap-4">
                                <WizImage
                                    src={project?.symbol_image}
                                    containerClassName="w-10 rounded-full overflow-hidden"
                                />
                                <Text className="text-ti1 font-semibold w-full truncate">{project?.symbol}</Text>
                                <Text className="w text-center text-ti2">Priority : {project?.priority}</Text>
                                <div className="w">
                                    <Text
                                        className={`${
                                            project?.status === 'active'
                                                ? 'bg-tag_green_light text-font_green'
                                                : 'bg-tag_red_light text-font_red'
                                        } text-ti3 py-[2px] px-2 rounded-[5px] text-center w-fit ml-auto`}>
                                        {project?.status}
                                    </Text>
                                </div>
                                <Text className="text-right text-body3 text-font03 col-span-4">
                                    Last Updated : {localTimeString(new Date(project?.updated_at)?.getTime() / 1000)}
                                </Text>
                            </div>
                        ))}
                </article>

                {/* create */}
                {active !== 'default' && (
                    <>
                        <div className="w-[1px] h-screen bg-line02" />
                        <article className="relative">
                            <Text className="text-h2 text-left text-font01">
                                {active === 'create' ? 'Create' : 'Edit'} Project
                            </Text>
                            <div className="mt-4 max-w-[500px] p-4 border border-line02 bg-white rounded-[5px] grid grid-cols-[40px_1fr_70px_auto] items-center gap-4 relative">
                                {active === 'detail' && (
                                    <Text className="text-body3 text-font03 col-span-4">
                                        Project ID : {detailData?.id}
                                    </Text>
                                )}
                                <div className="">
                                    <div
                                        onClick={() => symbolImageRef?.current?.click()}
                                        className="w-10 h-10 border border-line02 rounded-full cursor-pointer hover:border-primary overflow-hidden relative">
                                        {body?.symbol_image ? (
                                            <WizImage
                                                src={`${body?.symbol_image}?type=webp&width=80`}
                                                containerClassName="w-full"
                                                className="w-full"
                                            />
                                        ) : (
                                            <div className="  absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
                                                <WizImage src={img_placeholder} className="w-[30px]" />
                                            </div>
                                        )}
                                    </div>
                                    <input
                                        type={'file'}
                                        onChange={e => onChangeThumbnail(e)}
                                        ref={symbolImageRef}
                                        className={'hidden'}
                                        accept="image/jpg,image/png,image/webp"
                                    />
                                </div>

                                <UnderLineInput
                                    inputClassName={'w-full text-body2'}
                                    onChanged={text => setBody(prev => ({...prev, symbol: text}))}
                                    value={body.symbol}
                                    placeholder={'Project Name'}
                                />

                                <UnderLineInput
                                    inputClassName={'w-full text-center text-body2'}
                                    type="number"
                                    onChanged={text => setBody(prev => ({...prev, priority: Number(text)}))}
                                    value={body.priority}
                                    placeholder={'Priority'}
                                />

                                <div className="">
                                    <WizSelectButton
                                        data={selectList}
                                        onChange={e => {
                                            setBody(prev => ({...prev, status: e.id}))
                                        }}
                                        activeValue={selectList?.find(item => item.id === body.status)}
                                        className={'md:mx-auto'}
                                    />
                                </div>
                            </div>

                            <div className="mt-4">
                                <WizButton
                                    text={`${active === 'create' ? 'Create' : 'Edit'} Project`}
                                    type="primary"
                                    onClick={async () => {
                                        console.log({
                                            ...body,
                                            id: id,
                                        })
                                        if (active === 'create') {
                                            const result = await createTraderMap(body)

                                            if (result?.data && result?.status === 200) {
                                                setActive('default')
                                                alert(`Trader Map Project Created : ${body?.symbol}`)
                                                refetch()
                                            }
                                        } else if (active === 'detail') {
                                            const result = await editTraderMap({
                                                ...body,
                                                id: id,
                                            })
                                            console.log(result)

                                            if (result?.data && result?.status === 200) {
                                                setActive('default')
                                                alert(`Trader Map Project Edited : ${body?.symbol}`)
                                                refetch()
                                                detailRefetch()
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </article>
                    </>
                )}
            </div>
        </PageLayout>
    )
}
